import React, { useEffect, useState } from "react";
import { Page, LoadingMsg } from "components/common";
import { Doughnut, Pie, HorizontalBar } from "react-chartjs-2";
import { PayrollClient } from "services";
import MainCard from "./MainCard";
import { Row, Col } from "reactstrap";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';


function niceNumbers(number, minimumFractionDigits = 2, maximumFractionDigits = 2) {
  const formattedNumber = number.toLocaleString(undefined, {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  const withoutFraction = formattedNumber.endsWith('.00') ? formattedNumber.split('.')[0] : formattedNumber;

  return withoutFraction.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
const DynamicChart = ({ data, title, chartName }) => {
  const chartType = chartName === 'doughnut' ? 'doughnut' : (chartName === 'horizontalbar' ? 'horizontalbar' : 'pie');

  const ChartComponent = {
    pie: Pie,
    horizontalbar: HorizontalBar,
    doughnut: Doughnut,
  }[chartType];

  return (
    <div style={{ marginTop: '20px' }}>
      {title && <h4 className="font-weight-light">{title}</h4>}
      <ChartComponent data={data} />
    </div>
  );
};

const NotFound = ({ title }) => {

  return (
    <div className="text-muted d-flex align-items-center" style={{ marginTop: "50%", marginBottom: "50%", fontSize: "1.6em", flexDirection: "column"}}>
      <div>
        <i className="fas fa-exclamation mb-2" style={{fontSize: "1.8em",}}></i>
      </div>
      <div>
        <Trans>No {title} Data Found</Trans>
      </div>
    </div>
  );
};

const MetricCard = ({ title, value }) => (
  <div className="col-12 text-white text-center flex-column py-2 my-2" style={{ backgroundColor: 'rgb(54, 162, 235)', borderRadius: "5px" }}>
    <div className="col-12 my-2 h6">{title}</div>
    <div className="col-12 my-2 ">{value}</div>
  </div>
);

const MiniCard = ({ label, value, color }) => (
  <div style={{ backgroundColor: color, color: '#fff', borderRadius: "5px" }} className="col p-2 m-2">
    <p style={{ fontSize: '0.9em', margin: 0 }}>{label}:</p>
    <strong style={{ fontSize: '1.5em' }}>{value}</strong>
  </div>
);

const BlockCard = ({ title, data, colors }) => (
  <div className="text-center" style={{ padding: '16px', marginTop: '16px', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
    <h3 style={{ marginBottom: '16px', fontSize: '1.2em', zIndex: 1 }}>{title}</h3>
    <div className="row">
      {data.labels.map((label, index) => (
        <MiniCard key={label} label={label} value={niceNumbers(data.datasets[0].data[index])} color={colors[index]} />
      ))}
    </div>
  </div>
);

const HR = (item, data) => {

  const payrollClient = PayrollClient();

  const [totalLoans, setCheckedLoans] = useState();
  const [timeOff, setTimeOff] = useState();
  const [eList, setEList] = useState();
  const [payRuns, setPayRuns] = useState();

  const { t } = useTranslation()

  {/* Calling The APIs */ }

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const responseLoans = await payrollClient.get("loans");
        const loansData = responseLoans.data;
        setCheckedLoans(loansData);
        const responseTimeoff = await payrollClient.get("employee_holidays");
        const timeOffData = responseTimeoff.data;
        setTimeOff(timeOffData);
        const responseEList = await payrollClient.get("employees");
        const eListData = responseEList.data;
        setEList(eListData);
        const responsePayRuns = await payrollClient.get("tracks/report");
        const payrunsData = responsePayRuns.data;
        setPayRuns(payrunsData);
        setIsLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false)
      }
    };

    fetchData();
  }, []);

  {/* Functions Start */ }

  const totalEmployees = eList?.length || 0;

  const processData = (data) => {
    let pendingSalary = {};

    for (const month in data) {
      const monthData = data[month]["No Track"];

      for (const employee in monthData) {
        const amount = monthData[employee]['total_cost'] || monthData[employee];

        pendingSalary[employee] = (pendingSalary[employee] || 0) + amount;
      }
    }

    return pendingSalary;
  };

  const pendingSalary = processData(payRuns);

  const calculateTotalSum = (pendingSalary) => {
    let totalAmount = 0;

    for (const employee in pendingSalary) {
      const amount = pendingSalary[employee];

      const cleanedAmount = parseFloat(String(amount).replace(/[^0-9.]/g, ''));

      if (!isNaN(cleanedAmount)) {
        totalAmount += cleanedAmount;
      }
    }

    return totalAmount;
  };

  const totalPayableS = calculateTotalSum(pendingSalary);

  function processEmployeeData(data) {
    const listActive = data ? data.filter((list) => list.status === 'Active').length : 0;

    const totalSalary = data ? data.reduce((acc, list) => acc + parseFloat(list.salary), 0) : 0;

    return {
      listActive,
      totalSalary: totalSalary.toFixed(2),
    };
  }

  const {
    listActive,
    totalSalary,
  } = processEmployeeData(eList);


  function processAccountData(data) {
    const length = data ? data.length : 0;
    const employee = data ? data : [];
    let lengthApprovedTime = 0;
    let lengthToReviewTime = 0;
    let lengthRejectedTime = 0;
    let lengthOnLeave = 0


    if (length > 0) {
      const currentDate = new Date();
      const currentDateTimestamp = currentDate.getTime();

      for (let i = 0; i < length; i++) {
        if (employee[i].approved === true) {
          lengthApprovedTime++;
        } else if (employee[i].approved === null) {
          lengthToReviewTime++;
        } else if (employee[i].approved === false) {
          lengthRejectedTime++;
        }

        const startingDate = new Date(employee[i].starting);
        const endingDate = new Date(employee[i].ending);

        if (currentDateTimestamp >= startingDate.getTime() && currentDateTimestamp <= endingDate.getTime()) {
          lengthOnLeave++;
        }
      }
    } else {
      console.log("No data available");
    }

    return {
      lengthApprovedTime,
      lengthToReviewTime,
      lengthRejectedTime,
      lengthOnLeave,
    };
  }

  const {
    lengthApprovedTime,
    lengthToReviewTime,
    lengthRejectedTime,
    lengthOnLeave,
  } = processAccountData(timeOff);

  function processLoanData(data) {

    const lengthRunningLoans = data
      ? data.filter((loan) => loan.calculated_status === 'Running').length
      : 0;

    const lengthPendingLoans = data
      ? data.filter((loan) => loan.calculated_status === 'Pending').length
      : 0;

    const lengthApprovedLoans = data
      ? data.filter((loan) => loan.approved === true).length
      : 0;

    const lengthRejectedLoans = data
      ? data.filter((loan) => loan.calculated_status === 'Rejected').length
      : 0;

    return {
      lengthPendingLoans,
      lengthRunningLoans,
      lengthApprovedLoans,
      lengthRejectedLoans,
    };
  }

  const {
    lengthPendingLoans,
    lengthRunningLoans,
    lengthApprovedLoans,
    lengthRejectedLoans,
  } = processLoanData(totalLoans);



  let shiftCount = {};

  if (Array.isArray(eList)) {
    shiftCount = {};

    eList.forEach((employee) => {
      const shiftName = employee.shift_adj?.name;

      if (shiftName) {
        shiftCount[shiftName] = (shiftCount[shiftName] || 0) + 1;
      }
    });

    //console.log(shiftCount);
  } else {
    console.log('eList is not found/is being searched.');
  }

  //console.log(shiftCount);

  let nationCount = {};

  if (Array.isArray(eList)) {
    nationCount = {};

    eList.forEach((employee) => {
      const nationName = employee.nationality;

      if (nationName) {
        nationCount[nationName] = (nationCount[nationName] || 0) + 1;
      }
    });

    //console.log(nationCount);
  } else {
    console.error('eList is not an array or is undefined/null.');
  }

  //console.log(nationCount);


  const generateMetricCards = (countObject, maxToShow, defaultList) => {
    const numFound = Object.keys(countObject).length;
    const numDefaultToShow = Math.max(maxToShow - numFound, 0);
    const remainingDefaults = defaultList.filter(item => !Object.keys(countObject).includes(item));

    const cards = Array.from({ length: Math.min(maxToShow, numDefaultToShow + numFound) }, (_, index) => {
      const value = index < numFound ? countObject[Object.keys(countObject)[index]] || 0 : 0;
      const title = index < numFound ? Object.keys(countObject)[index] : remainingDefaults[index - numFound];
      return { title, value };
    });

    const sortedCards = cards.sort((a, b) => b.value - a.value);

    return sortedCards.map((card, index) => (
      <MetricCard key={index} title={t(card.title)} value={card.value} />
    ));
  };

  const shiftsMetricCards = generateMetricCards(shiftCount, 4, [t('Morning'), t('Afternoon'), t('Evening'), t('Night'), t('All Day')]);
  const nationsMetricCards = generateMetricCards(nationCount, 3, ['FR', 'SA', 'IN', 'AX', 'AE']);


  {/* Charts Data */ }

  const timeOffData = {
    labels: [t("Pending"), t("OnLeave"), t("Approved"), t("Rejected")],
    datasets: [
      {
        data: [lengthToReviewTime, lengthOnLeave, lengthApprovedTime, lengthRejectedTime],
        backgroundColor: ["#FFCE56", "#FF9F40", "#36A2EB", "#FF6384"],
        hoverBackgroundColor: ["#FFCE56", "#FF9F40", "#36A2EB", "#FF6384"],
      },
    ],
  };

  const loansData = {
    labels: [t("Pending"), t("Running"), t("Approved"), t("Rejected")],
    datasets: [
      {
        data: [lengthPendingLoans, lengthRunningLoans, lengthApprovedLoans, lengthRejectedLoans],
        backgroundColor: ["#FFCE56", "#FF9F40", "#36A2EB", "#FF6384"],
        hoverBackgroundColor: ["#FFCE56", "#FF9F40", "#36A2EB", "#FF6384"],
      },
    ],
  };

  const activeData = {
    labels: [t("Active"), t("Inactive")],
    datasets: [
      {
        data: [listActive, totalEmployees - listActive],
        backgroundColor: ["#36A2EB", "#FF6384"],
        hoverBackgroundColor: ["#36A2EB", "#FF6384"],
      },
    ],
  };

  const salaryData = {
    labels: [t("Salaries Payable"), t("Total Salaries")],
    datasets: [
      {
        data: [totalPayableS, totalSalary],
        backgroundColor: ["#FF9F40", "#FFCE56"],
        hoverBackgroundColor: ["#FF9F40", "#FFCE56"],
        stack: 'Stack 0',
      },
    ],
  };

  const salaryTwo = {
    labels: [t("Balance")],
    datasets: [
      {
        label: t("Salaries Payable"),
        backgroundColor: "#FF9F40",
        hoverBorderColor: "#FFF",
        data: [totalPayableS],
        stack: 'Stack 0',
      },
      {
        label: t("Total Salaries"),
        backgroundColor: "#FFCE56",
        hoverBorderColor: "#FFF",
        data: [totalSalary],
        stack: 'Stack 0',
      },
    ],
  };

  const [isLoading, setIsLoading] = useState(true);

  const [loadingMessage, setLoadingMessage] = useState();

  useEffect(() => {
    const firstTimeoutId = setTimeout(() => {
      setLoadingMessage(t("Loading time is taking longer than usual, Please check your employees or API/Network connection."));
    }, 15000);

    const secondTimeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 30000);

    return () => {
      clearTimeout(firstTimeoutId);
      clearTimeout(secondTimeoutId);
    };
  }, []);

  const cStyle = {
    cardsList: {
      className: "my-4",
    },
    common: {
      className: "my-4",
      style: { flex: '1 1 400px', maxWidth: 500 },
    },
  };

  const history = useHistory()

  const handleLink = (provided) => {
    return () => {
      history.push(provided);
    };
  };

  const createItems = (prefix, items) =>
    items.map(({ label, route }) => ({
      label,
      onClick: handleLink(`/payroll/${prefix}${route}`),
    }));

  const employeeItems = createItems("employees", [
    { label: 'New Employee', route: '/new' },
    { label: 'List of Employees', route: '' },
  ]);

  const timeOffItems = createItems("time_off", [
    { label: 'New Timeoff', route: '/new' },
    { label: 'List of Leaves', route: '' },
  ]);

  const loanItems = createItems("loans", [
    { label: 'New Loan', route: '/new' },
    { label: 'List of Loans', route: '' },
  ]);

  const salaryItems = [
    { label: 'Check Payrun', onClick: handleLink("/payroll/pay_runs") },
    { label: 'Open Report', onClick: handleLink("/payroll/tracks") },
  ];

  const orgName = (item && item.selectedOrganisation.name) || t("Organization Name");

  return (
    <Page title={t('HR Dashboard')} showTitle={false} >
      <div style={{ overflow: 'hidden' }}>
        <div className="text-center" style={{ marginBottom: "30px", fontSize: "2em", marginTop: "10px" }} >
          <p style={{ fontSize: "1.3em" }}><Trans>Welcome to the HR Dashboard</Trans></p>
          <p><strong>{orgName}</strong></p>
        </div>
        {isLoading ? (
          <div style={{ paddingTop: "2em" }} className="text-center justify-content-center">
            <LoadingMsg />
            <p style={{ fontSize: "1.2em" }}>{loadingMessage}</p>
          </div>
        ) : (
          <>
            {totalEmployees > 0 ? (
              <div>
                  <Row className="my-5">
                    
                    <div className="col-5">
                      <MainCard title={t("Time Off Status")} titleLink="time_off" dropDownItems={timeOffItems} history={history} hr>
                        <div style={{ textAlign: 'center' }}>
                          {timeOff.length > 0 ? 
                            <>
                              <DynamicChart data={timeOffData} /> 
                              <BlockCard title="Time-off" data={timeOffData} colors={timeOffData.datasets[0].backgroundColor} />
                            </>
                            : 
                            <NotFound title="Holiday" />
                          }
                        </div>
                      </MainCard>
                    </div>

                    <div className="col-2">
                      <MainCard title={t("Shifts")} titleLink="/payroll-new/shift" fsize="0.8em" history={history} threeDots={false}>
                        <div className="row flex-column">
                        {shiftsMetricCards}
                        </div>
                      </MainCard>
                    </div>

                    <div className="col-5">
                      <MainCard title={t("Loans Status")} titleLink="loans" dropDownItems={loanItems} history={history} hr>
                        <div style={{ textAlign: 'center' }}>
                          {totalLoans.length > 0 ? 
                            <>
                            <DynamicChart data={loansData} />
                            <BlockCard title="Loans" data={loansData} colors={loansData.datasets[0].backgroundColor} />
                            </>
                            :
                            <NotFound title="Loans" />
                          }
                        </div>
                      </MainCard>
                    </div>
                  </Row>


                  <div className="row my-5">
                      <div className="col-5">
                        <MainCard title={t("Active Status")} titleLink="employees" dropDownItems={employeeItems} history={history} hr>
                          <div style={{ textAlign: 'center' }}>
                            <DynamicChart data={activeData} chartName="doughnut" />
                            <BlockCard title={t("Active Employees")} data={activeData} colors={activeData.datasets[0].backgroundColor} />
                          </div>
                        </MainCard>
                      </div>

                      <div className="col-2">
                        <MainCard title={t("Nationality")} titleLink="employees" history={history} threeDots={false} fsize="0.7em">
                        <div className="row flex-column">
                          {nationsMetricCards}
                        </div>
                        <div className="row flex-column">
                          <MetricCard title={t("Total")} value={totalEmployees} />
                        </div>
                        </MainCard>
                      </div>

                      <div className="col-5">
                        <MainCard title={t("Salary Status")} titleLink="tracks" dropDownItems={salaryItems} history={history} hr>
                          <div style={{ textAlign: 'center' }}>
                            <DynamicChart data={salaryTwo} chartName="horizontalbar" />
                            <BlockCard title={t("Salaries")} data={salaryData} colors={salaryData.datasets[0].backgroundColor} />
                          </div>
                        </MainCard>
                      </div>
                  </div>
              </div>
            ) : (
              <div className="text-center">
                <MainCard title={t("Add/Edit Employees")} titleLink="employees" history={history} threeDots={false}>
                  <div className="text-muted">
                    <p style={{ marginTop: "1.3em", marginBottom: 0, fontSize: "1.2em" }}
                    ><Trans>Unfortunately the system couldn't find any employees.</Trans></p>
                    <p><Trans>Please check your connection/employees and try again.</Trans></p>
                  </div>
                </MainCard>
              </div>
            )}
          </>
        )}
      </div>
    </Page>
  );
};

const cardStyle = {
  backgroundColor: 'rgb(54, 162, 235)',
  color: 'rgb(255, 255, 255)',
  padding: '10px',
  borderRadius: '8px',
  textAlign: 'center',
  margin: '10px',
  width: '200px',
};

export default HR;
